import { CONFIG } from 'config-global'

export default function Title({ children }: { children: string }) {
  return (
    <title>{`${children} - ${CONFIG.appName}`}</title>
  )
}
